import { getDevMockLearningTools } from './dev/domains/content';
import {
  activateDevMockGoalPackage,
  cancelDevMockGoalPackage,
  getDevMockGoalsExperience,
  resetDevMockGoalsExperience,
  saveDevMockGoalDiscoveryCheckpoint,
  updateDevMockGoalMetricCheckIn
} from './dev/domains/goals';
import { getDevMockNotes, getDevMockNotesTemplate, saveDevMockNotes } from './dev/domains/notes';
import { getDevMockInternalUser, updateDevMockInternalUser } from './dev/domains/profile';
import {
  getDevMockGroups,
  getDevMockSessions,
  resetDevMockSessions,
  updateDevMockSession
} from './dev/domains/sessions';
import { getDevMockSurveys, getDevMockTermsHtml } from './dev/domains/surveys';
import { acceptDevMockTerms, getDevMockTasks, submitDevMockTask } from './dev/domains/tasks';
import { DEV_BYPASS_ACCESS_TOKEN, devBypassAuthUser, isDevAuthBypassEnabled } from './dev/fixtures/auth';
import { baseGoalsExperience, devPreviewQuote } from './dev/fixtures/goals';
import {
  baseInternalUser,
  coachCaseyProfile,
  leaderLeoProfile,
  newNoahProfile,
  veteranValProfile
} from './dev/fixtures/profile';
import { baseSessions } from './dev/fixtures/sessions';
import { baseTasks } from './dev/fixtures/tasks';
import { clone } from './dev/support/clone';
import { storageKeys, writeStorage } from './dev/support/storage';

// --- Public Bridge API ---

export {
  DEV_BYPASS_ACCESS_TOKEN,
  devBypassAuthUser,
  isDevAuthBypassEnabled,
  devPreviewQuote,
  getDevMockLearningTools,
  getDevMockSurveys,
  getDevMockTermsHtml,
  getDevMockNotesTemplate,
  getDevMockNotes,
  saveDevMockNotes,
  getDevMockInternalUser,
  updateDevMockInternalUser,
  getDevMockGroups,
  getDevMockSessions,
  resetDevMockSessions,
  updateDevMockSession,
  getDevMockTasks,
  submitDevMockTask,
  acceptDevMockTerms,
  getDevMockGoalsExperience,
  resetDevMockGoalsExperience,
  saveDevMockGoalDiscoveryCheckpoint,
  activateDevMockGoalPackage,
  cancelDevMockGoalPackage,
  updateDevMockGoalMetricCheckIn
};

// --- System State ---

/**
 * Resets the entire dev preview state to baseline.
 */
export function resetDevPreviewState() {
  // WHY: Comprehensive reset ensures a clean slate for debugging or scenario switching
  writeStorage(storageKeys.profile, clone(baseInternalUser));
  writeStorage(storageKeys.profileCoach, clone(coachCaseyProfile));
  writeStorage(storageKeys.profileLeader, clone(leaderLeoProfile));
  writeStorage(storageKeys.profileNew, clone(newNoahProfile));
  writeStorage(storageKeys.profileVeteran, clone(veteranValProfile));
  writeStorage(storageKeys.sessions, clone(baseSessions));
  writeStorage(storageKeys.tasks, clone(baseTasks));
  writeStorage(storageKeys.tasksCoach, clone(baseTasks));
  writeStorage(storageKeys.tasksLeader, clone(baseTasks));
  writeStorage(storageKeys.tasksNew, clone(baseTasks));
  writeStorage(storageKeys.tasksVeteran, clone(baseTasks));
  writeStorage(storageKeys.goals, clone(baseGoalsExperience));
  writeStorage(storageKeys.goalsCoach, clone(baseGoalsExperience));
  writeStorage(storageKeys.goalsLeader, clone(baseGoalsExperience));
  writeStorage(storageKeys.goalsNew, clone(baseGoalsExperience));
  writeStorage(storageKeys.goalsVeteran, clone(baseGoalsExperience));

  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(storageKeys.notes);
  }
}
